import { HtsReadinessPillarKey } from "../constants";
import { HtsReadinessPillarConfig } from "../schemas";

export const workExperience: HtsReadinessPillarConfig = {
  key: HtsReadinessPillarKey.WORK_EXPERIENCE,
  label: "Work Experience",
  definition:
    "Time and experience in paid employment. Related experience includes customer-service positions with direct customer or client interaction.",
  dataSourceNote: "Derived — employment history with its customer-interaction and promotion fields. Gaps already probed.",
  dimensions: [
    {
      key: "depthOfExperience",
      label: "Depth of Experience",
      weight: 0.35,
      anchors: {
        0: "No work experience.",
        25: "Under 12 months, or any length of part-time at 20 hours a week or less.",
        50: "12–24 months full-time, or 2+ years of substantial part-time work.",
        75: "24 months to 3 years full-time.",
        100: "3+ years full-time, or 5+ years with substantial part-time hours in the workforce overall.",
      },
    },
    {
      key: "relevance",
      label: "Relevance",
      weight: 0.3,
      anchors: {
        0: "No people-facing or related work.",
        25: "Limited or incidental customer contact.",
        50: "Regular customer/client-facing work in an unrelated field.",
        75: "Sustained customer-facing work, or some time in a directly related field.",
        100: "Sustained work in a directly related field (security, care, service delivery, public-facing roles relevant to the stream).",
      },
    },
    {
      key: "advancementTrustGiven",
      label: "Advancement & Trust Given",
      weight: 0.2,
      anchors: {
        0: "Any job that ended for cause (fired, or let go for conduct), however long ago — even when a later job added duties or trust.",
        25: "Same role throughout, in good standing.",
        50: "Informally given added responsibilities (training others, holding keys/cash, closing alone).",
        75: "Formal position advancement short of supervision.",
        100: "Promotion to a supervisory or management position.",
      },
    },
    {
      key: "stability",
      label: "Stability",
      weight: 0.15,
      anchors: {
        0: "Chronic short stints.",
        25: "Frequent changes. Gaps for family, health, education, or immigration are neutral and do not lower the score.",
        50: "Some changes, all explained; gaps resolved.",
        75: "Stable record with normal progression between employers.",
        100: "Highly stable — long tenures relative to years in workforce, or a clean upward progression.",
      },
    },
  ],
  topIndicators: [
    "A promotion",
    "An employer who kept adding responsibility",
    "Tenure that survived the candidate's school schedule",
  ],
  scoringNotes: [
    "Any job that ended for cause, however long ago, sets Advancement & Trust Given to 0, even when the current job shows nothing of the kind.",
    "Part-time work counts as substantial only above 20 hours a week; Depth of Experience measures time worked only.",
    "A job that ended in a firing caps Stability at 25.",
    "\"No work experience\" scores 0 on Depth and floors the pillar near 0 by design.",
    "Self-employment, family business, and military rank progression are scored on scope of responsibility, not on formal promotion.",
    "Seasonal, contract, and student work are scored on return to the same employer or completion of the term, not on number of employers.",
  ],
};
